import styled from "styled-components";

export const Tooltip = styled.div`
  position: relative;
  display: inline-block;
  cursor: pointer;

  .tooltip-text {
    visibility: hidden;
    width: auto;
    background-color: #333;
    color: #fff;
    text-align: center;
    border-radius: 5px;
    padding: 5px;
    position: absolute;
    z-index: 99999999999;
    top: auto; /* Adjust tooltip position */
    bottom: 60%;
    left: 45%;
    margin-left: -60px;
    opacity: 0;
    transition: opacity 0.3s;
    padding: 10px;
  }

  &:hover .tooltip-text {
    visibility: visible;
    opacity: 1;
  }
`;
